import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import { Button } from "../../../basic-ui-components/button/base/button.component";
import { BalanceButtonsGroupBox } from "./boxes/balance-buttons-group.box";
import { ButtonWrapperBox } from "./boxes/button-wrapper.box";

export interface BalanceBoxButtonsProps {
  onDeposit: () => void;
  onWithdraw: () => void;
}

export class UserBalanceButtons extends OrbitComponent<BalanceBoxButtonsProps> {
  render() {
    const translator = this.services.translation;

    return (
      <BalanceButtonsGroupBox>
        <ButtonWrapperBox className="cy-deposit-button">
          <Button preset="primaryInverted" onClick={() => {this.props.onDeposit()}} fullWidth>
            {translator.translate('DEPOSIT')}
          </Button>
        </ButtonWrapperBox>
        <ButtonWrapperBox className="cy-withdraw-button">
          <Button preset="info" onClick={() => {this.props.onWithdraw()}} fullWidth>
            {translator.translate('WITHDRAW')}
          </Button>
        </ButtonWrapperBox>
      </BalanceButtonsGroupBox>
    );
  }
}
